<template>
  <div
    class="nav-main"
    :class="[isScroll || feedNav || top_bg ? 'isScroll' : '']"
  >
    <div class="top_nav">
      <div class="logo">
        <router-link to="/" tag="div" class="logoInfo">
          <img :src="logoNameFun()" alt="" />
        </router-link>

        <div class="navList" v-if="!feedNav && !isdemandgiving">
          <top_menv class="nav-menu"></top_menv>
        </div>

        <div
          class="navList navList1"
          v-if="!feedNav && !isdemandgiving"
          style="display: flex; align-items: center"
        >
          <el-popover
            placement="bottom"
            title=""
            width="790"
            trigger="hover"
            :visible-arrow="false"
          >
            <div class="pop-deigo">
              <div>
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-style"
                >
                  <el-breadcrumb-item
                    v-for="item in breadcrumbData"
                    :key="item"
                    class="breadcrumb-item"
                    @click.native="breadcrumbBtn(item)"
                  >
                    <span class="base-style">{{ item }}</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-style">
                  <div
                    class="item-style"
                    v-for="city in procinceCity[currentCity]"
                    :key="city"
                    @click="cityBtn(city)"
                  >
                    {{ city }}
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
              <div>
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-style"
                >
                  <el-breadcrumb-item class="breadcrumb-item">
                    <span class="base-style">市县专区</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-style">
                  <div
                    class="item-style"
                    style="width: 28%; text-align: center; padding: 4px 8px"
                    v-for="stageitem in stageCity"
                    :key="stageitem.name"
                    :title="stageitem.name"
                    @click="stageBtn(stageitem)"
                  >
                    <img
                      :src="stageitem.img"
                      alt=""
                      style="width: 100%; height: 35px"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div slot="reference" class="butn-hover">
              <span style="display: flex; align-items: center">
                <img
                  :src="require('../../assets/images/area3.png')"
                  style="width: 23px; height: 23px; border-radius: 2px"
                />
                <span class="province-style">{{ currentCity }}</span>
                <i class="el-icon-arrow-down" style="color: #22222e"></i>
              </span>
            </div>
          </el-popover>
          <el-popover
            placement="bottom"
            title=""
            width="790"
            trigger="hover"
            :visible-arrow="false"
          >
            <div class="pop-deigo">
              <div>
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-style"
                >
                  <el-breadcrumb-item class="breadcrumb-item">
                    <span class="base-style">产业平台</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-style">
                  <div
                    class="item-style"
                    style="text-align: center"
                    :style="{ width: stageitem.w ? '20%' : '30%' }"
                    v-for="stageitem in produceStage"
                    :key="stageitem.name"
                    :title="stageitem.name"
                    @click="stageBtn(stageitem)"
                  >
                    <img
                      :src="stageitem.img"
                      alt=""
                      style="height: 40px"
                      :style="{ width: stageitem.w ? '145px' : '100%' }"
                    />
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
              <div>
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-style"
                >
                  <el-breadcrumb-item class="breadcrumb-item">
                    <span class="base-style">金融服务平台</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-style">
                  <div
                    class="item-style"
                    style="width: 20%; text-align: center"
                    v-for="stageitem in moenyStage"
                    :key="stageitem.name"
                    :title="stageitem.name"
                    @click="stageBtn(stageitem)"
                  >
                    <img
                      :src="stageitem.img"
                      alt=""
                      style="width: 145px; height: 40px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div slot="reference" class="butn-hover">
              <span style="display: flex; align-items: center">
                <img
                  :src="require('../../assets/images/home.png')"
                  style="
                    margin-left: 15px;
                    width: 20px;
                    height: 20px;
                    border-radius: 2px;
                  "
                />
                <span class="province-style">供应链平台体系</span>
                <i class="el-icon-arrow-down" style="color: #22222e"></i>
              </span>
            </div>
          </el-popover>

          <el-popover
            placement="bottom"
            title=""
            width="790"
            trigger="hover"
            :visible-arrow="false"
            ref="popoverRef"
          >
            <div class="pop-deigo">
              <div>
                <img
                  :src="require('../../assets/images/home/ediTitleImg.png')"
                  style="width: 91%; margin-bottom: 20px; cursor: pointer"
                  @click="clickediDover()"
                />
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-styleOne"
                >
                  <el-breadcrumb-item class="breadcrumb-item">
                    <span class="base-style">阳逻港区</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-styleyangluogang">
                  <div
                    class="item-styleyangluogang"
                    v-for="stageitem in yangluogangStage"
                    :key="stageitem.name"
                    :title="stageitem.name"
                    @click="yangluogangbtn(stageitem.url)"
                  >
                    <div class="item-styleOne">
                      <div class="item-styleOne">
                        <img
                          :src="stageitem.img"
                          alt=""
                          style="height: 50px; margin-right: 10px"
                          :style="{ width: stageitem.w ? '50px' : '50px' }"
                        />
                        <div class="item-styleTwo">
                          <div>{{ stageitem.name }}</div>
                          <div>{{ stageitem.text }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <el-breadcrumb
                  separator-class="el-icon-arrow-right"
                  class="breadcrumb-styleOne"
                >
                  <el-breadcrumb-item class="breadcrumb-item">
                    <span class="base-style">经开港区</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="city-styleyangluogang" v-if="wuhanPortZone">
                  <div
                    class="item-styleyangluogang"
                    v-for="stageitem in jingkaiStage"
                    :key="stageitem.name"
                    :title="stageitem.name"
                    @click="yangluogangbtn(stageitem.url)"
                  >
                    <div class="item-styleOne">
                      <div class="item-styleOne">
                        <img
                          :src="stageitem.img"
                          alt=""
                          style="height: 50px; margin-right: 10px"
                          :style="{ width: stageitem.w ? '50px' : '50px' }"
                        />
                        <div class="item-styleTwo">
                          <div>{{ stageitem.name }}</div>
                          <div>{{ stageitem.text }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 武汉港专区 -->
            <!-- <div slot="reference" class="butn-hover">
              <span style="display: flex; align-items: center">
                <img
                  :src="require('../../assets/images/yangluogangweb.png')"
                  style="
                    margin-left: 15px;
                    width: 25px;
                    height: 25px;
                    border-radius: 2px;
                  "
                />
                <span class="province-style">武汉港专区</span>
                <i class="el-icon-arrow-down" style="color: #22222e"></i>
              </span>
            </div> -->
          </el-popover>
        </div>
      </div>

      <div class="rightCon">
        <div v-if="key !== '/index'" class="elt">
          <router-link to="/" tag="a" class="img-title">
            <img src="@/assets/icon/home.png" alt="" class="home-img" />
            主页
          </router-link>
        </div>

        <div class="loginBox">
          <template v-if="userInfo.name || userInfo.phone">
            <div
              class="userInfo"
              :class="key != '/index' ? 'userInfoBefore' : ''"
            >
              <el-tooltip
                popper-class="atooltip"
                :content="userInfo.name || '手机用户'"
                placement="bottom"
                effect="light"
              >
                <div class="name" @click="jumpUserCenter">
                  {{ userInfo.name || "手机用户" }}
                </div>
              </el-tooltip>
              <div class="logOut" @click="logOut">登出</div>
            </div>
          </template>
          <template v-else>
            <div class="login" @click="loginFn">登录</div>
            <div class="logon" @click="register">注册</div>
          </template>
        </div>
      </div>
    </div>

    <div class="second_nav" v-if="feedNav && !isdemandgiving">
      <top_menv></top_menv>
    </div>

    <el-dialog
      title="理货网上查询系统"
      :visible.sync="dialogVisible"
      width="25%"
      center
      z-index="9999999999999999999999999999999999999999999999"
      :modal-append-to-body="true"
    >
      <img
        src="../../assets/images/zhonglitankuang.png"
        alt=""
        style="width: 100%"
      />
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <el-dialog
      class="dialogStyle"
      :visible.sync="dialogVisibleOne"
      width="35%"
      z-index="9999999999999999999999999999999999999999999999"
      :modal-append-to-body="true"
    >
      <img src="../../assets/images/eidDetails.png" alt="" />
      <span slot="footer" style="display: none"> </span>
    </el-dialog>
  </div>
</template>

<script>
import top_menv from "@/components/top_menv";
import { getCityUrl } from "@/api/user";
import { mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    isdemandgiving: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  components: {
    top_menv,
  },
  computed: {
    ...mapGetters(["userInfo", "feedNav", "top_bg"]),
    key() {
      return this.$route.path;
    },
    isshowTest() {
      return process.env.NODE_ENV === "testing";
    },
    // carouselList(){
    //   let result = [];
    //   for (let i = 0; i < this.stage[this.currentCity].length; i += 3) {
    //     result.push(this.stage[this.currentCity].slice(i, i + 3));
    //   }
    //   // console.log('result',result)
    //   return result
    // }
  },
  data() {
    return {
      activeName: "first",
      wuhanPortZone: false,
      isScroll: false,
      centerDialogVisible: false,
      produceDialogVisible: false,
      dialogVisible: false,
      dialogVisibleOne: false,
      yangluogangStage: [],
      jingkaigangStage: [],
      yangluobaoshuiyuanlist: [
        // {
        //   title:'阳逻保税园网上服务厅',
        //   // text:'经开港',
        //   img:require('@/assets/images/yangluobaoshuiyuan.png'),
        //   url:'https://login.hbgyl.com.cn/login?appId=c1b2bc52-b7bc-4e55-a345-ef34af4f2fc9&redirect_uri=https://www.whxgftz.com:5020/whylgyzs/ssoIndex&response_type=code'
        // },
        // {
        //   title:'新能源重卡网络运营平台',
        //   // text:'经开港',
        //   img:require('@/assets/images/xinnengyuanzhongka.png'),
        //   url:'http://manage.ylbsxny.com/'
        // },
      ],
      tieshuilianyunlist: [
        // {
        //     title:'阳逻铁水联运基地场站系统',
        //     // text:'经开港',
        //     img:require('@/assets/images/tishuilianyun.png'),
        //     url:'https://ylgtsly.hbgyl.com.cn:56000/hbtslycms'
        //   },
      ],
      procinceCity: {
        市县专区: [
          "武汉市",
          "襄阳市",
          "宜昌市",
          "黄石市",
          "十堰市",
          "荆州市",
          "荆门市",
          "鄂州市",
          "孝感市",
          "黄冈市",
          "咸宁市",
          "随州市",
          "恩施州",
          "仙桃市",
          "天门市",
          "潜江市",
          "神农架林区",
        ],
        武汉市: [],
        襄阳市: [],
        宜昌市: [],
        黄石市: [],
        十堰市: [],
        荆州市: [],
        荆门市: [],
        鄂州市: [],
        孝感市: [],
        黄冈市: [],
        咸宁市: [],
        随州市: [],
        恩施州: [],
        仙桃市: [],
        天门市: [],
        潜江市: [],
        神农架林区: [],
      },
      stageCity: [],
      // stage:{
      //   '咸宁市':[
      //     {
      //       name:'城市绿色货运配送公共信息平台',
      //       url:'https://www.xncslsps.com/home/home',
      //       // img:'https://www.xncslsps.com/img/logonew.ca732c61.png',
      //       img:require('@/assets/images/productStage/logonew.ca732c61.png'),
      //       w:false
      //     }
      //   ],
      //   '鄂州市':[
      //     {
      //       name:'三江港',
      //       url:'http://db.winjoinit.com:30085/#/home/',
      //       //  img:'http://db.winjoinit.com:30085/img/logo.3a1cd8d9.png',
      //      img:require('@/assets/images/productStage/logo.3a1cd8d9.png'),
      //        w:false
      //     }

      //   ],
      //   '十堰市':[
      //     {
      //       name:'房县供应链物流公共信息平台',
      //       url:'https://www.fxgylwl.com',
      //       //  img:'https://cjfx-static.hbkdwl.com/img/otLogo.png',
      //        img:require('@/assets/images/productStage/otLogo.png'),
      //        w:false
      //     },
      //      {
      //       name:'郧阳平台',
      //       url:'https://www.yygylwl.com/ot-website/home',
      //       // img:'https://yunyang-static-oss.hbkdwl.com/img/otLogo.png',
      //       img:require('@/assets/images/productStage/yyotLogo.png'),
      //        w:false
      //     },
      //     {
      //       name:'竹溪',
      //       url:'http://36.133.216.70:8093/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogozx.png'),
      //        w:false
      //     },
      //     {
      //       name:'郧西',
      //       url:'http://119.96.26.66:8091/ot-website/home',
      //        img:require('@/assets/images/productStage/yunxilogo.png'),
      //        w:false
      //     }
      //   ],
      //   '襄阳市':[
      //      {
      //       name:'南漳',
      //       url:'https://www.nzgylwl.com/ot-website/home',
      //        img:require('@/assets/images/productStage/xyotLogo.png'),
      //        w:false
      //     }, {
      //       name:'中谷',
      //       url:'https://www.hbgyl.com.cn/#/index',
      //        img:require('@/assets/images/productStage/spl.png'),
      //        w:false
      //     }

      //   ],
      //    '荆门市':[
      //      {
      //       name:'荆门',
      //       url:'http://171.43.135.201:7492/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogojm.png'),
      //        w:false
      //     },

      //   ],
      //    '恩施州':[
      //     {
      //       name:'鹤峰',
      //       url:'http://171.43.135.201:8492/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogohf2.png'),
      //        w:false
      //     }

      //   ],

      //   '市县专区':[
      //     {
      //       name:'房县供应链物流公共信息平台',
      //       url:'https://www.fxgylwl.com',
      //        img:require('@/assets/images/productStage/otLogo.png'),
      //       //  img:'https://cjfx-static.hbkdwl.com/img/otLogo.png',
      //        w:false
      //     },
      //     {
      //       name:'城市绿色货运配送公共信息平台',
      //       url:'https://www.xncslsps.com/home/home',
      //       img:require('@/assets/images/productStage/logonew.ca732c61.png'),
      //       //  img:'https://www.xncslsps.com/img/logonew.ca732c61.png',
      //       w:false
      //     },
      //     {
      //       name:'郧阳平台',
      //       url:'https://www.yygylwl.com/ot-website/home',
      //       // img:'https://yunyang-static-oss.hbkdwl.com/img/otLogo.png',
      //        img:require('@/assets/images/productStage/yyotLogo.png'),
      //        w:false
      //     },
      //     {
      //       name:'三江港',
      //       url:'http://db.winjoinit.com:30085/#/home/',
      //       //  img:'http://db.winjoinit.com:30085/img/logo.3a1cd8d9.png',
      //        img:require('@/assets/images/productStage/logo.3a1cd8d9.png'),
      //        w:false
      //     },
      //     {
      //       name:'南漳',
      //       url:'https://www.nzgylwl.com/ot-website/home',
      //        img:require('@/assets/images/productStage/xyotLogo.png'),
      //        w:false
      //     },
      //      {
      //       name:'荆门',
      //       url:'http://171.43.135.201:7492/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogojm.png'),
      //        w:false
      //     },
      //     {
      //       name:'竹溪',
      //       url:'http://36.133.216.70:8093/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogozx.png'),
      //        w:false
      //     },
      //     {
      //       name:'鹤峰',
      //       url:'http://171.43.135.201:8492/ot-website/home',
      //        img:require('@/assets/images/productStage/otLogohf2.png'),
      //        w:false
      //     },
      //     {
      //       name:'中谷',
      //       url:'https://www.hbgyl.com.cn/#/index',
      //        img:require('@/assets/images/productStage/spl.png'),
      //        w:false
      //     },
      //     {
      //       name:'郧西',
      //       url:'http://119.96.26.66:8091/ot-website/home',
      //        img:require('@/assets/images/productStage/yunxilogo.png'),
      //        w:false
      //     }
      //   ],
      // },
      produceStage: [
        //  {
        //     name:'华纺链',
        //     url:'https://www.huafl.com/',
        //     img:require('@/assets/images/productStage/1.png'),
        //     w:true
        //   },
        //   {
        //     name:'船舶供应链公共信息服务平台',
        //     url:'https://www.hbcjcbgyl.com/',
        //     img:require('@/assets/images/productStage/2.png'),
        //      w:true
        //   },
        //    {
        //     name:'鄂东煤',
        //     url:'https://www.ehctc.com/html/web/shouye/index.html',
        //     img:require('@/assets/images/productStage/3.png'),
        //      w:true
        //   },
        //    {
        //     name:'鹤峰',
        //     url:'http://171.43.135.201:8492/ot-website/home',
        //      img:require('@/assets/images/productStage/4.png'),
        //      w:true
        //   },
        //    {
        //     name:'新能源',
        //     url:'http://www.ylbsxny.com/',
        //      img:require('@/assets/images/productStage/xnyzk.png'),
        //      w:true
        //   },
        //    {
        //     name:'九州医院',
        //     url:'https://www.jzyygyl.cn/',
        //      img:require('@/assets/images/productStage/jiuzhoulogo.png'),
        //      w:true
        //   },
        //    {
        //     name:'长江汽车链',
        //     url:'https://www.cjqcl.com',
        //      img:require('@/assets/images/productStage/carlogo.png'),
        //      w:true
        //   },
        //    {
        //     name:'湖北煤炭供应链',
        //     url:'https://www.hbmt.cn/',
        //      img:require('@/assets/images/productStage/meitanlogo.png'),
        //      w:true
        //   },
        //    {
        //     name:'湖北国际贸易',
        //     url:'http://hubei.singlewindow.cn/index.html',
        //      img:require('@/assets/images/productStage/hubeimylogo.png'),
        //      w:true
        //   },
        //    {
        //     name:'武汉国际贸易',
        //     url:'https://www.whtradesdata.com.cn/hbgm/#/welcome',
        //      img:require('@/assets/images/productStage/wuhanmylogo.png'),
        //      w:true
        //   }
      ],
      moenyStage: [
        // {
        //     name:'鄂融通',
        //     url:'https://dfjrjgj.hubei.gov.cn/szxqyxyxx/enterprise/index.html',
        //     img:require('@/assets/images/productStage/5.png'),
        //     w:true
        //   },
        //   {
        //     name:'联链通',
        //     url:'https://llt.hbsltzb.com/#/',
        //     img:require('@/assets/images/productStage/6.png'),
        //     w:true
        //   },
        //   {
        //     name:'鄂港通',
        //     url:'https://egt.jdh.com.cn/main/login',
        //     img:require('@/assets/images/productStage/7.png'),
        //     w:true
        //   },
      ],
      // linkDataFun:[
      //   {
      //      moenyStage:[
      //         {
      //             name:'鄂融通',
      //             url:'https://dfjrjgj.hubei.gov.cn/szxqyxyxx/enterprise/index.html',
      //             img:require('@/assets/images/moneyStage/logo1.png'),
      //             w:true
      //           },
      //           {
      //             name:'联链通',
      //             url:'https://llt.hbsltzb.com/#/',
      //             img:require('@/assets/images/moneyStage/log2.png'),
      //             w:true
      //           },
      //           {
      //             name:'鄂港通',
      //             url:'https://egt.jdh.com.cn/main/login',
      //             img:require('@/assets/images/moneyStage/log3.png'),
      //             w:true
      //           },
      //       ],
      //   },
      //  {
      //    moenyStage:[
      //       {
      //           name:'鄂融通1',
      //           url:'https://dfjrjgj.hubei.gov.cn/szxqyxyxx/enterprise/index.html',
      //           img:require('@/assets/images/moneyStage/logo1.png'),
      //           w:true
      //         },
      //         {
      //           name:'联链通1',
      //           url:'https://llt.hbsltzb.com/#/',
      //           img:require('@/assets/images/moneyStage/log2.png'),
      //           w:true
      //         },
      //         {
      //           name:'鄂港通1',
      //           url:'https://egt.jdh.com.cn/main/login',
      //           img:require('@/assets/images/moneyStage/log3.png'),
      //           w:true
      //         },
      //     ],
      // }
      // ],

      breadcrumbData: ["湖北省"],
      currentCity: "市县专区",
      currentStage: "",
      logoName: "湖北供应链物流公共信息平台",
      logoObj: {
        index: require("@/assets/images/logo/title-logo.png"),
        government: require("@/assets/images/logo/title-logo.png"),
        industryCenter: require("@/assets/images/logo/title-logo.png"),
        logistics: require("@/assets/images/logo/title-logo.png"),
        logisticsBigData: require("@/assets/images/logo/title-logo.png"),
        supplychain: require("@/assets/images/logo/title-logo.png"),
        supplyFinance: require("@/assets/images/logo/title-logo.png"),
        roadFreight: require("@/assets/images/logo/title-logo.png"),
        waterage: require("@/assets/images/logo/title-logo.png"),
        otherIndex: require("@/assets/images/logo/title-logo.png"),
      },
      srcUrl:
        process.env.NODE_ENV === "testing"
          ? `https://cs-tyrz.hbgyl.com.cn/auth/realms/xsldev/protocol/openid-connect/login-status.html`
          : `https://tyrz.hbgyl.com.cn/auth/realms/xsldev/protocol/openid-connect/login-status.html`,
    };
  },
  created() {
    // this.initCityStage({csmc:this.currentCity,mkmc:'市县专区'})
    // this.initCityStage({csmc:'',mkmc:'产业平台'})
    // this.initCityStage({csmc:'',mkmc:'金融服务平台'})
    // this.initCityStage({csmc:'',mkmc:'阳逻港区'})
    // this.initCityStage({csmc:'',mkmc:'经开港区'})
    const stages = [
      { csmc: this.currentCity, mkmc: "市县专区" },
      { csmc: "", mkmc: "产业平台" },
      { csmc: "", mkmc: "金融服务平台" },
      { csmc: "", mkmc: "阳逻港区" },
      { csmc: "", mkmc: "经开港区" },
    ];
    const promises = stages.map((stage) => this.initCityStage(stage));
    Promise.all(promises).then(() => {
      this.wuhanPortZone = false;
      setTimeout(() => {
        this.wuhanPortZone = true;
      }, 500);
    });
  },
  mounted() {
    //console.log(this.$domain + "/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href))
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
    this.checkWidth();
    window.addEventListener("resize", () => {
      this.checkWidth();
    });
  },
  methods: {
    topUrl(path) {
      this.$router.push(path);
    },
    initCityStage(stage) {
      if (stage.mkmc == "市县专区") {
        this.stageCity = [];
        getCityUrl(stage)
          .then((res) => {
            if (res.code == 200) {
              this.stageCity = res.Rows.map((item) => {
                let obj = {
                  name: item.bt,
                  url: item.xtUrl,
                  img: "https://www.hbgyl.com.cn/dmdp-homepage" + item.tpUrl,
                  w: false,
                };
                return obj;
              });
              console.log("市县专区", this.stageCity);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (stage.mkmc == "产业平台") {
        this.produceStage = [];
        getCityUrl(stage)
          .then((res) => {
            if (res.code == 200) {
              this.produceStage = res.Rows.map((item) => {
                let obj = {
                  name: item.bt,
                  url: item.xtUrl,
                  img: "https://www.hbgyl.com.cn/dmdp-homepage" + item.tpUrl,
                  w: true,
                };
                return obj;
              });

              console.log("产业平台", this.produceStage);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (stage.mkmc == "金融服务平台") {
        this.moenyStage = [];
        getCityUrl(stage)
          .then((res) => {
            if (res.code == 200) {
              this.moenyStage = res.Rows.map((item) => {
                let obj = {
                  name: item.bt,
                  url: item.xtUrl,
                  img: "https://www.hbgyl.com.cn/dmdp-homepage" + item.tpUrl,
                  w: true,
                };
                return obj;
              });

              console.log("金融服务平台", this.moenyStage);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (stage.mkmc == "阳逻港区") {
        (this.yangluogangStage = []),
          getCityUrl(stage).then((res) => {
            console.log("阳逻港区", res);
            if (res.code == 200) {
              this.yangluogangStage = res.Rows.map((item) => {
                let obj = {
                  name: item.bt,
                  text: item.fl,
                  url: item.xtUrl,
                  img: "https://www.hbgyl.com.cn/dmdp-homepage" + item.tpUrl,
                  w: true,
                };
                return obj;
              });
            }
          });
      } else if (stage.mkmc == "经开港区") {
        (this.jingkaiStage = []),
          getCityUrl(stage).then((res) => {
            console.log("经开港区", res);
            if (res.code == 200) {
              this.jingkaiStage = res.Rows.map((item) => {
                let obj = {
                  name: item.bt,
                  text: item.fl,
                  url: item.xtUrl,
                  img: "https://www.hbgyl.com.cn/dmdp-homepage" + item.tpUrl,
                  w: true,
                };
                return obj;
              });
            }
          });
      }
    },
    checkWidth() {
      const clientWidth = document.body.clientWidth;
      if (clientWidth <= 1700) {
        this.$store.commit("user/SET_FEEDNAV", false);
      } else {
        this.$store.commit("user/SET_FEEDNAV", false);
      }
    },
    yangluogangbtn(url) {
      if (url == "zhongli") {
        this.$refs.popoverRef.doClose();
        this.dialogVisible = true;
      } else {
        window.open(url, "_blank");
      }
    },
    clickediDover() {
      console.log("点击了");
      this.$refs.popoverRef.doClose();
      this.dialogVisibleOne = true;
    },
    logoNameFun() {
      const title = this.key;
      let name = "otherIndex";
      if (title.indexOf("/index") > -1) {
        name = "index";
      }
      if (title.indexOf("/government") > -1) {
        name = "government";
      }
      if (title.indexOf("/industryCenter") > -1) {
        name = "industryCenter";
      }
      if (title.indexOf("/logistics") > -1) {
        name = "logistics";
      }
      if (title.indexOf("/logisticsBigData") > -1) {
        name = "logisticsBigData";
      }
      if (title.indexOf("/supplychain") > -1) {
        name = "supplychain";
      }
      if (title.indexOf("/supplyFinance") > -1) {
        name = "supplyFinance";
      }
      if (title.indexOf("/roadFreight") > -1) {
        name = "roadFreight";
      }
      if (title.indexOf("/waterage") > -1) {
        name = "waterage";
      }
      return this.logoObj[name];
    },

    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isScroll = scrollTop > 70;
    },
    loginFn() {
      this.$pvuv.getEvent("DRGN");
      window.location.href =
        this.$domain +
        "/dmdp-homepage/sync/SSO/login.do?frontRedirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    register() {
      this.$pvuv.getEvent("ZCGN");
      if (process.env.NODE_ENV === "testing") {
        window.location.href = "https://cs-login.hbgyl.com.cn/register";
      } else {
        window.location.href = "https://login.hbgyl.com.cn/register";
      }

      // console.log('this.$domain',this.$domain)

      // window.location.href = 'https://oauth.hubei.gov.cn:8443/hbyzw/zwfw/personinfo/personInfoAction_toPersonOrEntResign.do?appCode=hbzwfw&type=2'
      // window.location.href= 'https://oauth.hubei.gov.cn:8443/hbyzw/zwfw/personinfo/personInfoAction_toPersonOrEntResign.do?appCode=hbswlggxx&type=1'
      // this.$router.push({path: '/userRegister'})
    },
    logOut() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '退出登陆成功!'
          // });
          this.$store
            .dispatch("user/logout")
            .then((res) => {
              this.$router.push({ path: "/" });
              this.$pvuv.getEvent("DCGN");
            })
            .catch((error) => {
              console.log("error", error);
            });

          // window.location.href = this.$domain + "/dmdp-homepage/sync/SSO/logout.do?frontRedirectUrl=" + encodeURIComponent(window.location.href)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出登陆",
          });
        });
    },
    jumpUserCenter() {
      if (process.env.NODE_ENV === "testing") {
        window.open(
          "https://cs-login.hbgyl.com.cn/login?appId=6c5a3ba9-ed9f-4521-a7ca-45f4a921b737&redirect_uri=https://cs-user.hbgyl.com.cn&response_type=code",
          "_blank"
        );
      } else {
        window.open(
          "https://login.hbgyl.com.cn/login?appId=6c5a3ba9-ed9f-4521-a7ca-45f4a921b737&redirect_uri=https://user.hbgyl.com.cn&response_type=code",
          "_blank"
        );
      }
      // this.$pvuv.getEvent('进入用户详情')
    },
    jumpHome() {
      this.$router.push({ path: "/index" });
    },
    cityBtn(city) {
      if (this.breadcrumbData.indexOf(city) == -1) {
        this.breadcrumbData.push(city);
        this.currentCity = city;
        this.initCityStage({ csmc: this.currentCity, mkmc: "市县专区" });
      }
    },
    breadcrumbBtn(item) {
      if (this.breadcrumbData.indexOf(item) != this.breadcrumbData.length - 1) {
        let indexItem = this.breadcrumbData.indexOf(item);
        this.breadcrumbData.splice(indexItem + 1);
        if (item == "湖北省") {
          this.currentCity = "市县专区";
        } else {
          this.currentCity = item;
        }
        this.initCityStage({ csmc: this.currentCity, mkmc: "市县专区" });
      }
    },
    stageBtn(stage) {
      this.currentStage = stage.name;
      window.open(stage.url);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="less">
.area-style {
  padding: 2px 12px;
  border: 1px solid #333;
  color: #000;
  font-size: 16px;
  border-radius: 3px;
}
.province-style {
  color: rgb(34, 34, 46);
  font-size: 18px;
  padding: 2px;
}
.breadcrumb-style {
  margin-bottom: 25px;
}

.city-style {
  display: flex;
  justify-content: flex-start;
  // justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 25px;
}
.breadcrumb-styleOne {
  margin-bottom: 10px;
}
.breadcrumb-styleOne .breadcrumb-item:last-child .base-style {
  color: #409eff;
}
.city-styleyangluogang {
  display: flex;
  justify-content: flex-start;
  // justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}
.item-styleOne {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.item-styleTwo {
  // display: flex;
  text-align: left;
  flex-direction: column;
}
.item-styleTwo div:nth-child(1):hover {
  opacity: 0.6;
}
.item-styleTwo div:nth-child(1) {
  font-family: PingFang SC;
  font-size: 17px;
  font-weight: 600;
  line-height: 25px;
  text-align: left;
  padding-bottom: 2px;
}
.item-styleTwo div:nth-child(2) {
  font-family: PingFang HK;
  font-size: 14px;
  font-weight: 400;
  color: #409eff;
  line-height: 16px;
  text-align: left;
  border: 1px solid #409eff;
  display: inline-block;
  padding: 3px;
  border-radius: 3px;
}
.item-styleyangluogang {
  width: 42%;
  border: 1px solid #e8e8e8;
  border-radius: 7px;
  padding: 8px;
  cursor: pointer;
  background-color: #fcfcfc;
}
.item-styleyangluogang:hover {
  // opacity:0.6;
}
.item-styleyangluogang:hover * {
  // pointer-events: none; /* 防止子元素响应鼠标事件 */
}
.item-style {
  width: 17%;
  padding: 4px 3px;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #45484b;
  cursor: pointer;
}
.item-style:hover {
  background: #f1f2f3;
}
.base-style {
  font-weight: 700;
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
  font-size: 18px;
  cursor: pointer;
}
.breadcrumb-style .breadcrumb-item:last-child .base-style {
  color: #409eff;
}

.nav-main.isScroll {
  background: #fff;
  // border-bottom: 1px solid #e5e5e5;
}
.img-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #333;
  min-width: 72px;
}
.home-img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.nav-main {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  // background: rgba(0, 0, 0, 0.08);
  // backdrop-filter: blur(3px);

  .top_nav {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }

  .logo {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 40px;
    min-width: 1083px;
    img {
      width: 51px;
      margin-right: 9px;
    }

    .logoInfo {
      height: 40px;
      cursor: pointer;

      img {
        width: auto;
        height: 100%;
        object-fit: contain;
      }

      .logoTitle {
        height: 26px;
        font-size: 20px;
        font-weight: 700;
        color: #3d3d3d;
        line-height: 26px;
      }
    }
  }

  .second_nav {
    padding-left: 40px;
    height: auto;
    border-bottom: 0px solid #ddd;
  }

  .navList {
    /*width: 60%;*/
    margin-left: 50px;
  }

  .rightCon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // min-width: 558px;

    .elt {
      cursor: pointer;
      font-size: 18px;
      font-weight: 400;
      color: #22222e;
      line-height: 26px;
      margin-right: 18px;
    }
  }

  .loginBox {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .login {
      width: 78px;
      height: 100%;
      font-size: 18px;
      font-weight: 400;
      color: #000;
      line-height: 26px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .logon {
      width: 100px;
      height: 100%;
      background: #0256ff;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-bottom: 3px solid #0256ff;
    }

    .userInfo {
      box-sizing: border-box;
      padding: 0 10px 0 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // gap: 30px;
      font-size: 16px;
      position: relative;
      .name {
        max-width: 115px;
        color: #0256ff;
        font-size: 20px;
        // font-weight: 700;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .logOut {
        // margin-left: 20px;
        font-size: 16px;
        cursor: pointer;
        color: #767676;
      }
    }
    // .userInfoBefore:before{
    //   position: absolute;
    //   left: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   content: '';
    //   width: 1px;
    //   height: 18px;
    //   background: #dcdcdc;
    // }
  }

  // .loginBox:before {
  //   position: absolute;
  //   left: 0;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   content: '';
  //   width: 1px;
  //   height: 23px;
  //   background: rgba(255, 255, 255, 0.5);
  // }
}
.dem-giv {
  margin-right: 5px;
}

.isScroll .loginBox:before {
  background: #dddddd;
}
.pop-deigo {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.butn-hover {
  cursor: pointer;
}
.butn-hover:hover i {
  transform: rotateZ(180deg);
}
.butn-hover i {
  transition: transform 0.3s, -webkit-transform 0.3s;
}
@media (min-width: 1396px) and (max-width: 1580px) {
  .top_nav {
    .navList {
      margin-left: 35px;
    }
    .navList1 {
      margin-left: 55px;
    }
    .logo {
      padding-left: 8px;
      zoom: 0.86;
      img {
        width: 23px;
      }
    }
    .rightCon {
      zoom: 0.86;
    }

    .dem-giv {
      margin-right: 25px;
    }
    .has-giveing {
      padding: 0 12px;
    }
  }
}
@media (min-width: 1200px) and (max-width: 1396px) {
  .top_nav {
    .logoInfo {
      //zoom: .54;
    }
    .navList {
      margin-left: 8px;
    }
    .navList1 {
      margin-left: 55px;
    }
    .logo {
      padding-left: 3px;
      zoom: 0.76;

      img {
        width: 16px;
      }
    }
    .rightCon {
      zoom: 0.76;
    }
    .dem-giv {
      margin-right: 15px;
    }
    .has-giveing {
      padding: 0 8px;
    }
  }
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .top_nav {
    .logoInfo {
    }
    .navList {
      margin-left: 4px;
    }
    .navList1 {
      margin-left: 67px;
    }

    .logo {
      padding-left: 1px;
      zoom: 0.66;

      img {
        width: 12px;
      }
    }
    .rightCon {
      zoom: 0.66;
    }
    .dem-giv {
      margin-right: 10px;
    }
    .has-giveing {
      padding: 14px;
    }
    .has-giveing {
      padding: 0 6px;
    }
  }
}
@media (min-width: 400px) and (max-width: 1024px) {
  .top_nav {
    .logoInfo {
    }
    .navList {
      margin-left: 4px;
    }
    .navList1 {
      margin-left: 36px;
    }

    .logo {
      padding-left: 1px;
      zoom: 0.56;
      img {
        width: 12px;
      }
    }
    .rightCon {
      zoom: 0.56;
    }
    .dem-giv {
      margin-right: 10px;
    }
    .has-giveing {
      padding: 14px;
    }
    .has-giveing {
      min-width: 80px;
      padding: 0 6px;
    }
  }
}

.el-menu--horizontal {
  z-index: 2006;
  background-color: rgba(255, 255, 255, 0.8) !important;
}

.nav-main.logis .logo .logoInfo .logoTitle {
  color: #fff;
}

.nav-main.logis .logo .logoInfo {
  color: #fff;
}

.logis /deep/ .menus {
  .el-menu-item {
    color: #fff !important;

    a {
      color: #fff !important;
    }
  }
}

.logis /deep/ .menus {
  .el-menu-item.is-active {
    border-bottom-color: #fff !important;

    a {
      color: #fff !important;
    }
  }
}

.isScroll.logis .logo .logoInfo .logoTitle {
  color: #000;
}

.isScroll.logis .logo .logoInfo {
  color: #000;
}

.isScroll.logis /deep/ .menus {
  .el-menu-item {
    color: #000 !important;

    a {
      color: #000 !important;
    }
  }
}

.isScroll.logis /deep/ .menus {
  .el-menu-item.is-active {
    border-bottom-color: #000 !important;

    a {
      color: #000 !important;
    }
  }
}

.isScroll.logis /deep/ .menus {
  .is-active {
    .el-icon-arrow-up,
    .el-icon-arrow-down {
      color: #000 !important;
    }
  }
}

.main-container.style2 {
  .header {
    padding-top: 0 !important;
  }
}
</style>
<style>
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(0, 0, 0, 0.15) !important;
}
.atooltip .el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #fff !important;
}
.atooltip {
  height: 42px !important;
  line-height: 42px !important;
  color: #6d6d6d !important;
  background-color: #fff !important;
  padding: 0 20px !important;
  border-radius: 4px !important;
  border: 1px solid #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  font-size: 15px !important;
  font-weight: 500 !important;
}

.has-giveing {
  position: relative;
  padding: 0 14px;
  cursor: pointer;
}
.has-giveing:hover {
  opacity: 0.78;
}
.has-giveing:first-child::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 16px;
  background: #808695;
}
.has-giveing:after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 16px;
  background: #808695;
}
.el-popover {
  padding: 0;
}
</style>
<style scoped>
.dialogStyle /deep/.el-dialog__footer {
  padding: 0;
}
.dialogStyle /deep/.el-dialog__header {
  padding: 0;
}
.dialogStyle /deep/.el-dialog__body {
  padding: 0;
}
.dialogStyle /deep/ .el-dialog__body img {
  width: 100%; /* 图片宽度占满容器 */
  height: auto; /* 保持图片比例 */
  display: block; /* 移除图片下方的默认空白间隙 */
}
.dialogStyle {
  margin-top: -5vh;
}

/deep/ .el-menu.el-menu--horizontal > div {
  display: inline-block;
}

/deep/ .el-menu--horizontal .el-menu-item.is-active {
  color: #22222e;
  border-bottom: 2px #386ce8 solid !important;
  background-color: transparent;
}
/deep/ .el-dialog {
  /* margin-left: 22%; */
}
/deep/ .el-dialog__header {
  padding: 0;
  padding-top: 20px;
}
.menus {
  background-color: transparent;
}

.menus /deep/ .el-menu-item,
.menus /deep/ .el-submenu__title {
  font-size: 18px;
  padding: 0;
  color: #22222e;
  margin-right: 30px;
  height: 68px;
  line-height: 68px;
}

.second_nav .menus /deep/ .el-menu-item,
.second_nav .menus /deep/ .el-submenu__title {
  height: auto;
  line-height: 26px;
  padding-bottom: 29px;
}

.menus > div:last-child /deep/ .el-menu-item {
  margin-right: 0;
}

.menus /deep/ .el-menu-item:hover {
  background-color: transparent;
}

.menus .el-menu-item:hover {
  background-color: transparent;
}

.menus /deep/ .el-submenu__title:hover {
  background-color: transparent;
}

.menus /deep/ .el-submenu__icon-arrow {
  right: -20px;
}

.menus /deep/ .el-submenu__title i {
  color: #22222e;
  font-size: 16px;
}

.menus /deep/ .el-menu-item:focus {
  background-color: transparent;
}

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: 0px;
}

/deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
  color: #22222e !important;
}

/**
    菜单鼠标经过样式
   */
.el-menu-item:hover {
  background-color: transparent !important;
}

/deep/ .el-submenu > div:hover {
  background-color: transparent !important;
}

.el-menu-item:hover {
  opacity: 0.75;
}

.el-menu--horizontal .el-menu--popup .el-menu-item {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}

.el-menu--horizontal .el-menu-item.is-active {
  background-color: transparent !important;
}
/deep/ .el-carousel__indicators--outside button {
  width: 20px;
  height: 6px;
  background: #6089ed;
  border-radius: 3px 3px 3px 3px;
  opacity: 0.2;
  display: none;
}
/deep/ .el-carousel__indicators--outside .is-active button {
  background: #386ce8;
  opacity: 1;
  display: none;
}
/deep/ .el-carousel__indicators--outside {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/top_nav/index.vue